import styled from 'styled-components';

import ListItemHexagonSvg from '../media/list_item_hexagon.svg';

import {pxToEm} from './globalStyles';

export const wrapperAppUlFonSizePx = 20;
const WrapperAppUl = styled.ul`
  list-style: circle outside url(${ListItemHexagonSvg});
  margin: 0;
  font-size: ${pxToEm(wrapperAppUlFonSizePx)}em;
  line-height: 1.6;

  padding: 0 ${pxToEm(26) / pxToEm(wrapperAppUlFonSizePx)}em;

  > li {
    padding-left: ${pxToEm(20) / pxToEm(wrapperAppUlFonSizePx)}em;
  }
`;

export default WrapperAppUl;
